import { render, staticRenderFns } from "./DelivererOrdersManagement.vue?vue&type=template&id=768d9560&scoped=true"
import script from "./DelivererOrdersManagement.vue?vue&type=script&lang=js"
export * from "./DelivererOrdersManagement.vue?vue&type=script&lang=js"
import style0 from "./DelivererOrdersManagement.vue?vue&type=style&index=0&id=768d9560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d9560",
  null
  
)

export default component.exports